import { triggerDownload } from "./exportSources.js";

/**
 * Zip a list of { name, blob } entries into one Blob. STORE mode (no compression) —
 * inputs are already compressed. `name` may include folder paths ("dir/file.obj").
 */
export async function buildZipBlob(entries) {
  const { downloadZip } = await import("client-zip");
  const zipEntries = entries.map(({ name, blob }) => ({ name, input: blob }));
  return downloadZip(zipEntries).blob();
}

/**
 * Download a list of { name, blob } files: a single file is saved as-is under its
 * own name; several are bundled into one zip named `zipName`.
 */
export async function downloadFiles(files, zipName) {
  if (files.length === 1) {
    triggerDownload(files[0].blob, files[0].name);
  } else {
    triggerDownload(await buildZipBlob(files), zipName);
  }
}
